import {_get, _post} from "./Axios";

export default class PenilaianApi {
    static getRef() {
        return _get('/booking/Penilaian/ref')
    }

    static get(booking_id, is_partner) {
        return _get('/booking/penilaian/by_booking/' + booking_id + "/" + (is_partner ? 1 : 0))
    }

    static save(booking_id, data, is_partner) {
        return _post('/booking/Penilaian/save', {
            booking_id,
            data,
            is_partner: is_partner ? 1 : 0,
        })
    }

    static update(data) {
        return _post('/booking/Penilaian/update', {
            data,
        })
    }
}